module.exports = __webpack_public_path__ + "static/img/lb7.2397db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb7.png
// module id = UF3u
// module chunks = 0